import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const LoaderWrapper = styled(FlexRow)`
    position: absolute;
    z-index: 10000;
    width: 100%;
    top: 0;
    left: 0;
    height: 100vh;

    justify-content: center;
    align-items: center;

    background: ${rgba(colorsPalettes.midnight[300], 0.7)};
`;
